var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-container"},[_c('div',{staticClass:"middle-line"},[_c('div',{staticClass:"btn-circle"}),_c('div',{staticClass:"btn-circle-active"}),_c('div',{staticClass:"btn-circle"})])])
}]

export { render, staticRenderFns }